import React from 'react';
import PropTypes from 'prop-types';
import { Space } from 'antd';

const PaginationSummary = ({ meta }) => (
  <Space className="d-flex justify-content-end" style={{ color: '#d9d9d9' }}>
    Showing{meta?.from}-{meta?.to}of{meta?.total}listings
  </Space>
);

export default PaginationSummary;

PaginationSummary.defaultProps = {
  meta: {},
};

PaginationSummary.propTypes = {
  meta: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
    total: PropTypes.number,
  }),
};
